import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { Button, Field, Input } from '@/shared/ui'
import { api, ApiError } from '@/shared/api/client'
import { useAccount } from '@/entities/session'
import styles from './ui/CompanyPage.module.css'

export function PasswordForm() {
  const { data: account } = useAccount()
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [confirm, setConfirm] = useState('')
  const [pending, setPending] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)
  const [show, setShow] = useState(false)
  if (account?.impersonation) return <div className={styles.panel}><div className={styles.panelHead}>Смена пароля недоступна при входе от имени клиента</div></div>

  async function submit(event: FormEvent) {
    event.preventDefault()
    setError('')
    if ([...next].length < 8) { setError('Новый пароль должен содержать не меньше 8 символов'); return }
    if (new TextEncoder().encode(next).length > 72) { setError('Новый пароль слишком длинный (максимум 72 байта)'); return }
    if (next !== confirm) { setError('Пароли не совпадают'); return }
    if (next === current) { setError('Новый пароль должен отличаться от текущего'); return }
    setPending(true)
    try {
      await api.post<void>('/account/password', { currentPassword: current, newPassword: next, confirmPassword: confirm })
      setCurrent(''); setNext(''); setConfirm(''); setSuccess(true)
    } catch (err) { setError(err instanceof ApiError ? err.message : 'Не удалось изменить пароль. Попробуйте ещё раз.') }
    finally { setPending(false) }
  }

  return <section className={styles.panel} aria-label="Смена пароля">
    <div className={styles.panelHead}>Сменить пароль</div>
    <div style={{ padding: 'var(--space-5)' }}>
      {success ? <div role="status">Пароль изменён. Все предыдущие сессии завершены. Войдите с новым паролем.<p style={{ marginTop: 16 }}><Link to="/login" reloadDocument>Войти с новым паролем →</Link></p></div> :
        <form onSubmit={submit} style={{ display: 'grid', gap: 16, maxWidth: 440 }}>
          <input type="text" name="username" autoComplete="username" value={account?.user.email ?? ''} readOnly hidden />
          <Field label="Текущий пароль" required>{props => <Input {...props} name="currentPassword" type={show ? 'text' : 'password'} autoComplete="current-password" required value={current} onChange={e => setCurrent(e.target.value)} />}</Field>
          <Field label="Новый пароль" required>{props => <Input {...props} name="newPassword" type={show ? 'text' : 'password'} autoComplete="new-password" required value={next} onChange={e => setNext(e.target.value)} />}</Field>
          <Field label="Повторите новый пароль" required>{props => <Input {...props} name="confirmPassword" type={show ? 'text' : 'password'} autoComplete="new-password" required value={confirm} onChange={e => setConfirm(e.target.value)} />}</Field>
          <label><input type="checkbox" checked={show} onChange={e => setShow(e.target.checked)} /> Показать пароли</label>
          <p>Не меньше 8 символов. После смены нужно войти заново на всех устройствах.</p>
          {error && <div role="alert" style={{ color: 'var(--danger)' }}>{error}</div>}
          <Button type="submit" loading={pending} disabled={!current || !next || !confirm || pending}>Изменить пароль</Button>
        </form>}
    </div>
  </section>
}
